// extracted by mini-css-extract-plugin
export default {"item":"ThemeSwitchContextItem_item__Zp9cO"};